module.exports = __webpack_public_path__ + "static/media/hydrophobic-video.311eaf5b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/oakleyStealth/hydrophobic-video.mp4
// module id = 3502
// module chunks = 0